import type { FunctionComponent, ReactNode, Ref } from 'react';

import type { AssetKindT } from 'utils';

import IconAudio from 'assets/images/icon-audio-16px.svg';
import IconDocument from 'assets/images/icon-doc-16px.svg';
import IconImage from 'assets/images/icon-image-16px.svg';
import IconVideo from 'assets/images/icon-video-16px-b.svg';

import './style.scss';

const ICONS: Record<AssetKindT, ReactNode> = {
  AUDIO: <IconAudio />,
  DOCUMENT: <IconDocument />,
  IMAGE: <IconImage />,
  VIDEO: <IconVideo />,
};

type PropsT = {
  kind: AssetKindT;
  name: string;
  ref?: Ref<HTMLDivElement>;
};

export const FileIcon: FunctionComponent<PropsT> = ({ kind, name, ref }) => (
  <div ref={ref} styleName="container">
    {ICONS[kind]}
    <div styleName="label">{name}</div>
  </div>
);
